import { BrightnessContrastEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const BrightnessContrast = wrapEffect(BrightnessContrastEffect)
